const API_DOMAIN = process.env.REACT_APP_DOMAIN;

export const ENV = '/api/v3';
export const COLLAB_ENV = '/api';
export const DEFAULT_LANGUAGE = 'English';
export const SFDC_DOMAIN = process.env.REACT_APP_SFDC_DOMAIN_HINT;
export const GE_DOMAIN = process.env.REACT_APP_SSO_DOMAIN_HINT;
export const CLEAR_SFDC_COOKIES_LINK = 'https://uat2-gehc.cs171.force.com/geidp/secur/deleteSessionCookie.jsp';
export const NATIVE_REDIRECT = 'nativeRedirect';

const SERVICE = {
  SUPPORT: {
    FETCH_FAQ: '/qaList',
    SUPPORT_FEEDBACK: '/feedback',
    LOAD_PRODUCT_UPDATE: '/public/productUpdate',
    GET_COUNTRIES: '/public/getCountries',
    UNAUTHENTICATED_FAQ: '/public/support',
    GEO_IP_LOCATOR:'/native/public/location',
  },
  PROFILE: {
    GET_PROFILE_DETAILS: '/user/profile',
    UPDATE_PROFILE_DETAILS: '/user/info',
    GET_LANGUAGE_DETAILS: '/languages',
    GET_JOB_DEPARTMENT_DETAILS: '/getProfileDataByTypeAndLang',
    EMAIL_REGEX: '/getEmailRegexExp'
  },
  SUBSCRIPTION: {
    GET_SUBSCRIPTION_DETAILS: '/statistics',
    GET_SUBSCRIPTION_INFO: '/user/info',
  },
  USER: {
    VALIDATE_EMAIL: '/status',
    REGISTER_USER: '/register',
    UPDATE_USER: '/access',
  },
  CUSTOMER: {
    GET_CUSTOMERS: '/subscriptions',
    GET_CUSTOMER_USERS: '/subscription/users',
    ACTIVATION_KEY_INFO: '/licenseKey',
    GET_ONLINE_CUSTOMERS: '/subscription/users/online',
  },
  PEOPLE: {
    GET_PEOPLE: '/admin/subscriptions',
  },
  SUBMIT_DISPUTE: '/submitDispute',
  RESCHEDULE_CANCEL_URL: '/reschedulecancel/url',
  GET_USER_NAME: '/native/internal/user/',
  COLLAB: {
    GET_NATIVE_APP_DATA: '/native/internal/appdata',
    GET_NATIVE_APP_DOWNLOAD_URL: '/native/app/getDownloadData'
  },
  REGISTRATION: {
    GET_ACCOUNT_STATUS: '/account/status',
    GET_FACILITIES: '/child/facilities',
    UPDATE_ADMIN_TERMS: '/admin/accept',
  },
};

export { API_DOMAIN, SERVICE };
